import { Action } from '@ngrx/store';
import { UserActionType } from 'app/core/user/state/actions/user-action-type.enum';

import { UserInterface } from 'app/core/user/models';

export class UpdateUser implements Action {
  public readonly type: UserActionType = UserActionType.UserUpdate;
  public readonly payload: UserInterface ;

  constructor(user: UserInterface) {
    this.payload = user;
  }
}

export class UserUpdated implements Action {
  public readonly type: UserActionType = UserActionType.UserUpdated;

  constructor(public readonly payload: UserInterface) { }
}

export class UserUpdateFailed implements Action {
  public readonly type: UserActionType = UserActionType.UserUpdateFailed;

  constructor(public readonly payload: UserInterface) { }
}
